/**
 * Single customer-facing status presentation for the public RO tracker.
 * Status pill and Current Status card must both use this map — never drift.
 */

export type JobTrackerCustomerStatusCopy = {
  title: string;
  message: string;
};

const FALLBACK: JobTrackerCustomerStatusCopy = {
  title: "In Progress",
  message: "Your repair is being handled by our service team.",
};

/** Authoritative customer wording keyed by backend job status. */
export const JOB_TRACKER_CUSTOMER_STATUS: Record<string, JobTrackerCustomerStatusCopy> = {
  received: {
    title: "Received",
    message: "Your item has been received and is with our technician now.",
  },
  diagnosis: {
    title: "Under Assessment",
    message: "Your item is currently being assessed by our technician.",
  },
  pending_finance: {
    title: "Under Assessment",
    message: "Your item is currently being assessed by our technician.",
  },
  awaiting_commercial_review: {
    title: "Under Assessment",
    message: "Your item is currently being assessed by our technician.",
  },
  ready_to_send_to_customer: {
    title: "Under Assessment",
    message: "Your item is currently being assessed by our technician.",
  },
  awaiting_customer_confirmation: {
    title: "Your Approval Is Required",
    message: "We have completed our assessment. Please review the repair quotation below.",
  },
  customer_declined: {
    title: "Repair Declined",
    message:
      "The repair will not proceed. Our team will contact you regarding the return of your item.",
  },
  pending_parts: {
    title: "Preparing for Repair",
    message: "We are arranging the parts required for your repair.",
  },
  in_progress: {
    title: "Repair in Progress",
    message: "Our technician is currently working on your item.",
  },
  repair_complete: {
    title: "Repair Completed",
    message: "Your repair is complete. We are preparing the next arrangements.",
  },
  awaiting_payment: {
    title: "Payment Required",
    message:
      "Your repair is complete. Please make payment so we can arrange collection or delivery.",
  },
  awaiting_collection: {
    title: "Ready for Collection",
    message: "Your item is ready for collection or delivery.",
  },
  closed: {
    title: "Completed",
    message: "Your item has been returned and this repair is complete.",
  },
};

export const JOB_TRACKER_SUPPORTED_BACKEND_STATUSES = [
  "received",
  "diagnosis",
  "pending_finance",
  "awaiting_commercial_review",
  "ready_to_send_to_customer",
  "awaiting_customer_confirmation",
  "customer_declined",
  "pending_parts",
  "in_progress",
  "repair_complete",
  "awaiting_payment",
  "awaiting_collection",
  "closed",
] as const;

export function getJobTrackerCustomerStatus(status: string): JobTrackerCustomerStatusCopy {
  return JOB_TRACKER_CUSTOMER_STATUS[status] ?? FALLBACK;
}
